import {AddToCartButton, useProductOptions} from '@shopify/hydrogen';
import {useRef} from 'react';

/**
 * Wrapper around Hydrogen's `<AddToCartButton />` which will
 * display a disabled 'sold out' button if variant is not available for sale
 */

type Props = {
  label?: string;
  quantity?: number;
  showSoldOut?: boolean;
  children?: any;
  upsellShopify?: any;
  upsellAdded?: boolean;
  setUpsellAdded?: any;
  title?: string;
  isOutOfStock?: boolean;
  preOrderExpectedDeliveryDate: Date | null;
};

export default function SelectedVariantAddToCartButton({
  label = 'Add to cart',
  quantity = 1,
  showSoldOut = true,
  upsellShopify,
  upsellAdded,
  setUpsellAdded,
  title,
  isOutOfStock,
  preOrderExpectedDeliveryDate,
  children,
}: Props) {
  const {selectedVariant} = useProductOptions();
  const attributes = preOrderExpectedDeliveryDate
    ? [
        {
          key: 'Pre-order',
          value: `Expected to be back in stock ${preOrderExpectedDeliveryDate.toLocaleDateString(
            'en-US',
            {month: 'long', year: 'numeric'},
          )}`,
        },
      ]
    : [];

  if (!selectedVariant || (!showSoldOut && !selectedVariant.availableForSale)) {
    return null;
  }

  //Upsell data
  const {variants} = upsellShopify || {};
  const upsell = variants?.edges[0]?.node;

  //custom add to cart function
  const performed = useRef<any>();
  const buttonRef = useRef<any>();
  const upsellRef = useRef<any>();

  const AddUpsell = async () => {
    upsellAdded && upsellRef?.current?.click();

    await new Promise((r) => setTimeout(r, 500));
    setUpsellAdded(false);
  };

  const handleCustomOnClick = async (event: any) => {
    if (performed.current) {
      performed.current = false;
      //add to GTM dataLayer
      return window.dataLayer.push({
        event: 'addToCart',
        ecommerce: {
          currencyCode: selectedVariant?.priceV2?.currencyCode,
          add: {
            products: [
              {
                name: title,
                id: selectedVariant?.id,
                price: selectedVariant?.priceV2?.amount,
                quantity: quantity,
              },
            ],
          },
        },
      });
    }
    event.preventDefault(); // stop default behaviour

    await AddUpsell();
    await new Promise((r) => setTimeout(r, 500));

    buttonRef.current.click(); // trigger button default behaviour
    performed.current = true; // prevents retriggering
  };

  return (
    <>
      {/* Product Button */}
      <AddToCartButton
        className="btn-standard"
        disabled={isOutOfStock || !selectedVariant.availableForSale}
        quantity={quantity}
        variantId={selectedVariant?.id}
        onClick={handleCustomOnClick}
        buttonRef={buttonRef}
        data-testid="add-to-cart-button"
        attributes={attributes}
      >
        {isOutOfStock ? 'Sold out' : children || label}
      </AddToCartButton>
      {/* Upsell Button */}
      {upsellShopify && (
        <AddToCartButton
          className="btn-standard pointer-events-none invisible absolute"
          disabled={isOutOfStock || !upsell?.availableForSale}
          quantity={quantity}
          variantId={upsell?.id}
          buttonRef={upsellRef}
        >
          test
        </AddToCartButton>
      )}
    </>
  );
}
